// Native selects/buttons inherit font-size from their wrapper (the unlayered
// normalize in index.css overrides Tailwind text-* on form controls), so the
// containers set `text-sm` and these classes only handle shape and color.
// Phones get taller controls for touch; `sm:` returns to the compact size.
const actionBase =
  'inline-flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-lg px-3.5 font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-50 sm:h-8';

export const primaryActionClassName = `${actionBase} bg-teal-500 text-neutral-950 hover:bg-teal-400`;

export const approveActionClassName = `${actionBase} bg-emerald-500 text-neutral-950 hover:bg-emerald-400`;

export const rejectActionClassName = `${actionBase} border border-red-500/40 bg-red-500/10 text-red-200 hover:bg-red-500/20`;

export const secondaryActionClassName = `${actionBase} border border-neutral-700 bg-neutral-800/60 font-medium text-neutral-200 hover:bg-neutral-800`;

export const panelSelectClassName =
  'h-10 w-full appearance-none rounded-lg border border-neutral-700 bg-neutral-800 pl-3 pr-8 text-white focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500 disabled:cursor-not-allowed disabled:opacity-60 sm:h-8';

export const panelInputClassName =
  'w-full rounded-lg border border-neutral-700 bg-neutral-800 px-3 py-2 text-white placeholder:text-neutral-500 focus:border-teal-500 focus:outline-none focus:ring-1 focus:ring-teal-500';

export const fieldLabelClassName =
  'text-[11px] font-semibold uppercase tracking-wide text-neutral-500';
